import * as actionTypes from '../actionTypes';

export const setProvisoSkip = (data) => ({
  type: actionTypes.SET_PROVISO_SKIP_AU,
  data,
});
